<template>
  <div>
    <app-header title="Add Energy Provider"/>

    <validation-observer tag="form" class="container container-max-md" @submit.native.prevent ref="validation">
      <form class="card" @submit.prevent>
        <div class="card-body card-body-lg">
          <h2 class="mb-4">Energy Provider Details</h2>

          <validation-provider tag="div" class="mb-3" name="name" rules="required" >
            <label>Energy Provider Name</label>
            <c-input v-model="stateName" />
            <c-help-block />
          </validation-provider>

          <validation-provider tag="div" class="mb-3" name="url" rules="required" >
            <label>Website</label>
            <c-input v-model="stateUrl" />
            <c-help-block />
          </validation-provider>

          <div class="d-flex mt-4">
            <c-button type="submit" variant="primary" @click="submit" validate class="ms-auto" >
              Create Energy Provider
            </c-button>
          </div>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import { stateMapper, helperMethods, helperComputed } from '@/vuex/modules/settings/energy-providers'
import { toast } from '@chameleon/chameleon-vue'
export default {
  mixins: [stateMapper],

  computed: helperComputed,

  created () {
    this.resetEnergyProvider()
  },

  beforeDestroy () {
    this.resetEnergyProvider()
  },

  methods: {
    ...helperMethods,

    async submit () {
      const payload = {
        name: this.stateName,
        url: this.stateUrl
      }
      await this.storeEnergyProvider(payload)
      toast('Saved successfully', 'success')
      this.$router.push({ name: 'settings.energy-providers' })
    }
  }
}
</script>
